import axios from 'axios'
import { showToast } from 'vant'

// 获取环境变量
const env = import.meta.env

// 创建axios实例
const requests = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器
requests.interceptors.request.use(
  async (config) => {
    // 从本地存储获取token
    const token = localStorage.getItem('wecom_access_token')
    
    // 如果没有token，通过登录接口获取授权URL
    if (!token) {
      // 避免登录接口本身再次触发重定向
      if (!config.url.includes('/auth/login')) {
        try {
          // 创建一个新的axios实例来避免拦截器循环
          const authInstance = axios.create({
            baseURL: env.VITE_API_BASE_URL,
            timeout: 15000
          })
          
          const loginResponse = await authInstance.get('/api/v1/auth/login?redirect=' + encodeURIComponent(window.location.href))

          if (
            loginResponse.data &&
            loginResponse.data.data &&
            loginResponse.data.data.authorize_url
          ) {
            // 跳转到授权页面
            window.location.href = loginResponse.data.data.authorize_url
          }
        } catch (loginError) {
          console.error('登录请求失败:', loginError)
          // showToast('登录失败，请刷新页面重试')
        }
        // return Promise.reject(new Error('未登录，请重新登录'))
      }
    } else {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  },
)

// 响应拦截器
requests.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    const { response } = error
    // 未授权时进行授权
    if (response && response.status === 401) {
      // 清除本地存储的token和认证状态
      localStorage.removeItem('wecom_access_token')
      localStorage.removeItem('is_authenticated')
      
      try {
        const loginResponse = await requests.get('/api/v1/auth/login')

        if (
          loginResponse.data &&
          loginResponse.data.data &&
          loginResponse.data.data.authorize_url
        ) {
          // 跳转到授权页面
          window.location.href = loginResponse.data.data.authorize_url
        }
      } catch (loginError) {
        console.error('登录请求失败:', loginError)
        // showToast('登录失败，请刷新页面重试')
      }

      // return Promise.reject(new Error('未授权，请重新登录'))
    }

    // 处理其他错误
    const errorMessage = response?.data?.message || error.message || '请求失败'
    // 仅在调试模式下打印错误日志
    if (env.VITE_DEBUG === 'true') {
      console.error('响应错误:', errorMessage)
    }
    showToast(errorMessage)

    return Promise.reject(error)
  },
)

export default requests
